import React from 'react';
import PropTypes from 'prop-types';

import RouteBundler from 'components/RouteBundler';
import AuthorizationWrapper from 'components/Auth/AuthorizationWrapper';
import roles from 'core/roles';

import ProjectsTable from './Table';
import ProjectView from './View';
import ProjectEditor from './Edit';
import ProjectNew from './New';

/* eslint-disable prettier/prettier */
const routes = [
  { path: '', component: ProjectsTable, exact: true },
  { path: ':id/view', component: ProjectView, exact: true },
  { path: ':id/edit', component: ProjectEditor, exact: true },
  { path: 'new', component: ProjectNew, exact: true },
];
/* eslint-enable prettier/prettier */

class Project extends React.Component {
  static propTypes = {
    me: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    return (
      <RouteBundler
        prefix={`${this.props.match.path}/`}
        routes={routes}
        me={this.props.me}
      />
    );
  }
}

export default AuthorizationWrapper([roles.ADMIN, roles.PROJECT_MANAGER])(
  Project,
);
